import React from "react";
import { useMatches, Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "ui/components/breadcrumb";
import { useCaseStudyBreadcrumbData } from "./useCaseStudyBreadcrumbData";

export default function BreadcrumbNav() {
  const matches = useMatches();
  const data = useCaseStudyBreadcrumbData();
  const crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb) && match.pathname !== "/")
    .map((match) => {
      let crumb = match.handle.crumb;
      let path = match.pathname.replace('casestudies', 'case-studies');
      return {
        crumbLabel: typeof crumb === "function" ? crumb(data) : crumb,
        pathname: path,
      };
    });
  if (crumbs.length === 0) return null;
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <React.Fragment key={crumb.pathname}>
              {index > 0 && <BreadcrumbSeparator className="hidden md:block" />}
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{crumb.crumbLabel}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.pathname}>{crumb.crumbLabel}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
} 